// extracted by mini-css-extract-plugin
export default {"amount":"style_amount__I56rA","redColor":"style_redColor__90ohK","greenColor":"style_greenColor__CXzCG","summaryCell":"style_summaryCell__6KgKA","content":"style_content__S9Qrh"};